import * as React from 'react';
import PropTypes from 'prop-types';
//import Tabs from '@mui/material/Tabs';
//import Tab from '@mui/material/Tab';
import {Tabs, Tab, Box, Typography} from "@material-ui/core";
/*import {
    FormTab,
    TextInput,
} from 'react-admin';*/
//import {validateReq} from "../utils/validateTable";
// import {localesConfig} from "../utils/config";
import RelatedTable from "./RelatedTable";
// import {useTranslate} from "react-admin";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{p: 3}}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const BaseTab = (props) => {

    // const translate = useTranslate();
    const {related_table} = props;

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{width: '100%'}} style={{border: '1px solid #ccc', borderRadius: 8, zIndex: 2}}>
            <Box sx={{borderBottom: 1, borderColor: 'divider'}}
                 style={{backgroundColor: 'aliceblue', borderRadius: '8px 8px 0 0 '}}>
                {/*<Tabs value={value} onChange={handleChange} aria-label="basic tabs example">*/}
                <Tabs
                    value={value}
                    onChange={handleChange}
                    // indicatorColor="primary"
                    // textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                >

                    {related_table.map((it, ind) => {
                        return (
                            <Tab label={it.name} {...a11yProps(ind)} />
                        )
                    })
                    }
                </Tabs>
            </Box>
            {related_table.map((it, ind) => {
                return (
                    <TabPanel value={value} index={ind} style={{width: "fit-content"}}>
                        <RelatedTable resourceTbl={it.name} parameters={it} {...props}/>
                    </TabPanel>
                )
            })
            }
        </Box>

    );
}
